import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/hamburger.scss';

const HeaderMenu = ({ items }) => {
  const [open, setOpen] = useState(false);
  const [itemsOpen, setItemsOpen] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const closer = (e) => {
      if (
        !e.target.closest('.hamb__items') &&
        !e.target.classList.contains('hamb__icon')
      ) {
        setOpen(false);
      } else if(e.target.classList.contains('hamb__icon') && open === true) {
        setOpen(false)
      } else {
        setOpen((prev) => true);
      }
    };

    window && window.addEventListener('mouseup', closer);

    return () => {
      window.removeEventListener('mouseup', closer);
    };
  }, [open]);

  return (
    <div className={`headermenu__container ${open ? 'open' : ''}`}>
      <div className='hamb__icon'>
        <div></div>
        <div></div>
        <div></div>
      </div>
      
      <ul className='hamb__items'>
        {items &&
          items.map((item) => (
            <Fragment key={item.id}>
              <li
                key={item.id}
                onClick={() =>
                  setItemsOpen((prev) =>
                    prev === item.title ? null : item.title
                  )
                }>
                {item.title}
              </li>
              <ul className={`${itemsOpen === item.title ? 'open' : ''}`}>
                {item.children.map((child) => (
                  <li
                    key={child.id}
                    onClick={() => {
                      setOpen(false);
                      navigate(`/products/cat/${child.id}`);
                    }}>
                    {child.title}
                  </li>
                ))}
              </ul>
            </Fragment>
          ))}
      </ul>
    </div>
  );
};

export default HeaderMenu;
